import { TruClose } from '@uswitch/spark-icons/tru'

const Modal = ({ children, close, isOpen, type, variant = 'default' }) => {
  const getStyles = element => `elements.modal.variants.${variant}${element ? '.' + element : ''}`
  const handleKeypress = ({ key }) => (key === 'Enter' || key === 'Escape') && close()

  return (
    <div
      sx={{
        position: 'fixed',
        backgroundColor: 'rgba(0,0,0,0.5)',
        top: 0,
        right: 0,
        left: 0,
        bottom: 0,
        display: isOpen ? 'flex' : 'none',
        justifyContent: 'center',
        alignItems: 'center',
        p: 'sm',
        zIndex: 110,
        variant: getStyles(),
      }}
      onClick={close}
      onKeyPress={handleKeypress}
      role='link'
      tabIndex={0}
    >
      <div
        sx={{
          width: type === 'calculator' ? ['90%', '50%'] : '100%',
          maxWidth: [500, 1300],
          maxHeight: '100%',
          backgroundColor: 'white',
          position: 'relative',
          overflowY: 'auto',
          variant: getStyles('content'),
        }}
      >
        <div sx={{ position: 'absolute', top: 'md', right: 'md', variant: getStyles('icon') }}>
          <TruClose color={'rgba(0,0,0,0.6)'} size={18} />
        </div>
        {children}
      </div>
    </div>
  )
}

export default Modal
